export const KNOWLEDGE_SKILLS = "/api/pa/knowledge-skills"
export const KNOWLEDGE_SKILL = "/api/pa/knowledge-skills/:param"
export const KNOWLEDGE_SKILL_ACTIVATE = "/api/pa/knowledge-skills/:param/activate"
export const EXPORT_KNOWLEDGE_SKILL = "/api/pa/knowledge-skills/export"
export const IMPORT_KNOWLEDGE_SKILL = "/api/pa/knowledge-skills/import"
